<template>
  <div class="horizontal-list" v-resize="onResize">
    <v-layout ref="container" class="scroll-container" :style="style">
      <v-flex v-for="(item, i) in items" :key="i" :ref="'item' + i" d-flex grow>
        <slot v-bind="item"></slot>
      </v-flex>
    </v-layout>
    <v-hover>
      <v-btn
        fab
        v-show="canMoveLeft()"
        class="prev-button"
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 12 : 2}`"
        @click="scrollLeft"
      >
        <v-icon>navigate_before</v-icon>
      </v-btn>
    </v-hover>
    <v-hover>
      <v-btn
        fab
        v-show="canMoveRight()"
        class="next-button"
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 12 : 2}`"
        @click="scrollRight"
      >
        <v-icon>navigate_next</v-icon>
      </v-btn>
    </v-hover>
  </div>
</template>

<script>
export default {
  props: ["items"],
  data() {
    return {
      item: "",
      current: 0,
      noOfItems: this.$props.items.length,
      slidesToShow: 1,
      itemWidth: 0,
      containerWidth: 0,
      translateValue: 0,
      wrap: false
    };
  },
  methods: {
    onResize() {
      // console.log("onresize");
      this.getWidth();
      // console.log(this.$vuetify.breakpoint);
      this.wrap = this.wrapOnSm && this.$vuetify.breakpoint.smAndDown;
      // console.log(this.wrap);
      if (this.wrap) {
        this.current = 0;
        this.slidesToShow = this.noOfItems;
      }
      this.move();
    },
    scrollLeft() {
      if (this.canMoveLeft()) {
        this.current -= 1;
      }
      this.move();
    },
    scrollRight() {
      if (this.canMoveRight()) {
        this.current += 1;
      }
      this.move();
    },
    canMoveLeft() {
      return this.current > 0;
    },
    canMoveRight() {
      return this.current < this.noOfItems - this.slidesToShow;
    },
    move() {
      if (!this.canMoveRight()) {
        // console.log("cannot move right");
        this.current = this.noOfItems - this.slidesToShow;
      }
      if (!this.canMoveLeft()) {
        // console.log("cannot move left");
        this.current = 0;
      }
      this.translateValue = this.current * this.itemWidth;
    },
    getWidth() {
      this.itemWidth = this.item.clientWidth;
      this.containerWidth = this.$refs.container.clientWidth;
      this.slidesToShow = this.containerWidth / this.itemWidth;
    }
  },
  computed: {
    style() {
      return { transform: `translateX(${this.translateValue * -1}px)` };
    }
  },
  updated() {
    this.$nextTick(function() {
      // Code that will run only after the
      // entire view has been re-rendered
      this.item = this.$refs.item0[0];
      // this.noOfItems = this.$props.items.length;
      this.getWidth();
    });
  },
  watch: {
    items(value) {
      this.noOfItems = this.$props.items.length;
      // console.log(this.noOfItems);
    }
  }
};
</script>

<style>
.horizontal-list {
  position: relative;
  overflow-x: hidden;
  padding: 24px 16px;
}
.horizontal-list .scroll-container {
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  will-change: transform;
}
.horizontal-list .scroll-container .horizontal-list-item {
  display: inline-flex;
  max-width: 400px;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 100%;
}
.horizontal-list .prev-button,
.horizontal-list .next-button{
  position: absolute !important;
  top: 50%;
  transform: translateY(-50%);
}
.horizontal-list .prev-button {
  left: 0px;
}
.horizontal-list .next-button {
  right: -4px;
}
@media (min-width: 600px) {
  .horizontal-list {
    padding: 24px 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HorizontalList.vue